import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c38ce32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "submenu background-transition" }
const _hoisted_2 = { class: "submenu-title" }
const _hoisted_3 = {
  key: 0,
  class: "submenu-title-icon icon"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "submenu-content" }


export default /*#__PURE__*/_defineComponent({
  name: 'SubMenu',
  props: {
  title: {
    type: String,
    required: true
  },
  icon: String,
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createElementVNode("img", {
                src: __props.icon,
                alt: "icon"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass('submenu-title-text ' + (!__props.icon ? 'no-icon' : ''))
        }, _toDisplayString(__props.title), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})